import { request } from '../request'

// 我承接的列表
export function getUndertakes(params) {
  return request({
    url: '/wjsettlement/center/statement/page/iUndertake',
    method: 'get',
    params
  })
}

// 我承接的导出PDF
export function downloadUndertakePDF(data) {
  return request({
    url: '/wjsettlement/center/projectExcel/downloadUndertake',
    method: 'post',
    data
  })
}

// 我承接的导出Excel
export function downloadUndertakeExcel(data) {
  return request({
    url: '/wjsettlement/center/projectExcel/downloadFeeSettlementUndertakeExcel',
    method: 'post',
    data
  })
}

// 获取我承接的项目明细界面列表
export function getUndertakeDetailList(params, data) {
  return request({
    url: '/wjsettlement/center/investigatorDetail/page',
    method: 'post',
    params,
    data
  })
}

// 确认结算单详情
export function getSettlementDetail(investigatorStatementId = '') {
  return request({
    url: '/wjsettlement/center/investigatorStatement/getInfoById',
    method: 'get',
    params: { investigatorStatementId }
  })
}

// 确认结算单
export function confirmSettlement(data) {
  return request({
    url: '/wjsettlement/center/investigatorStatement/confirmEntrust',
    method: 'post',
    data
  })
}

// 确认收款
export function confirmReceivables(data) {
  return request({
    url: '/wjsettlement/center/investigatorStatement/confirmEntrustForPay',
    method: 'post',
    data
  })
}
